import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateUserRoleEntity } from '../../domain/entities/UpdateUserRoleEntity'

export class UpdateUserRoleModel extends UpdateUserRoleEntity {
  roleIds!: number[]
  constructor(dataDto: UpdateUserRoleEntity) {
    super()
    mapEntityProperties<UpdateUserRoleModel>(this, dataDto, {
      exclude: ['roles'],
      map: {
        roleIds: dataDto.roles?.map((role) => role.id)
      }
    })
  }
}
